/*
 * Manage the visibility and styles of fullscreen iframe by listening to
 * specific messages ('show_fullscreen' / 'hide_fullscreen').
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import debugFactory from 'debug';

import { CheckoutIpc } from './types';

const debug = debugFactory('ingrid:bootstrap');

export function setupFullscreenControl(iframe: HTMLIFrameElement, ipc: CheckoutIpc) {
  ipc.listen(payload => {
    if (payload.name === 'fullscreen_modal_show') {
      show();
    }
  });
  ipc.listen(payload => {
    if (payload.name === 'fullscreen_modal_hide') {
      hide();
    }
  });

  const show = () => {
    iframe.style.opacity = '1';
    iframe.style.height = '100%';

    debug('Fullscreen shown');

    disableBodyScroll(iframe);
  };

  const hide = () => {
    iframe.style.opacity = '0';
    iframe.style.height = '0';

    debug('Fullscreen hidden');

    enableBodyScroll(iframe);
  };

  /**
   * HACK: When using height=0 in chrome the browser stops rendering process in
   * the iframe, thus when the iframe re-appears it shows the old content for
   * some period of time.
   */

  // hide by default
  iframe.style.opacity = '0';

  // add styles here
  iframe.style.zIndex = '2147483647';

  iframe.style.position = 'fixed';
  iframe.style.height = '0';
  iframe.style.width = '100%';
  iframe.style.left = '0';
  iframe.style.top = '0';
}
